import React, { Component } from 'react';

//componentes
import ChatInterno from './Chat'

class Index extends Component {

    render(){
        return(
            <div>
                <ChatInterno />
            </div>
        );
    }

}
export default Index;